/* tslint:disable */
/* eslint-disable */
import { exists } from '../runtime';
/**
 * @export
 * @interface RefreshRequest
 */
export interface RefreshRequest {
    refreshToken?: string | null;
}

export function RefreshRequestFromJSON(json: any): RefreshRequest {
    return RefreshRequestFromJSONTyped(json, false);
}

export function RefreshRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RefreshRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'refreshToken': !exists(json, 'refresh_token') ? undefined : json['refresh_token'],
    };
}

export function RefreshRequestToJSON(value?: RefreshRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'refresh_token': value.refreshToken,
    };
}
